namespace TabAurous.Production {
    export interface QualityInspectionForm {
        TransDate: Serenity.DateEditor;
        RefVoucherId: Serenity.IntegerEditor;
        RefTransId: Serenity.StringEditor;
        RefVoucherNo: Serenity.StringEditor;
        EmployeeId: Serenity.IntegerEditor;
        UserId: Serenity.IntegerEditor;
    }

    export class QualityInspectionForm extends Serenity.PrefixedContext {
        static formKey = 'Production.QualityInspection';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!QualityInspectionForm.init)  {
                QualityInspectionForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.StringEditor;

                Q.initFormType(QualityInspectionForm, [
                    'TransDate', w0,
                    'RefVoucherId', w1,
                    'RefTransId', w2,
                    'RefVoucherNo', w2,
                    'EmployeeId', w1,
                    'UserId', w1
                ]);
            }
        }
    }
}
